import { LinearProgress } from '@mui/material';
import React from 'react';
import { StyledProgressTask } from './index.style';
import Typography from 'component/MarketPlace/Typography';
import { LeaverTask } from '../LeaverCard';
export interface ITaskProgress {
  doneList?: LeaverTask[];
  total?: number;
  progress?: number;
  locale: any;
}
const TaskProgress = (props: ITaskProgress) => {
  const { doneList, total = 0, progress = 0, locale } = props;
  return (
    <>
      {total > 0 ? (
        <StyledProgressTask paddingRight="16px" paddingTop="8px">
          <Typography variant="h6">
            {doneList?.length}/{total} {locale?.leaverCard?.complete}
          </Typography>
          <LinearProgress variant="determinate" value={progress * 100} />
        </StyledProgressTask>
      ) : (
        <Typography variant="body2">
          {locale?.leaverCard?.noTasksAssign}
        </Typography>
      )}
    </>
  );
};
export default TaskProgress;
